import { connect } from 'react-redux';
import type { LocationState } from 'redux-first-router';

import type { State as PortfoliosState } from '@/components/DeprecatedPortfolios/redux/reducers';

import Dashboard from '../components/Dashboard';
import type { Props as DashboardProps } from '../components/Dashboard';

import {
  getMyMarketAndIndustryEntitiesSelector,
  getMyMarketKeysSelector,
  getMyIndustryKeysSelector,
} from '../redux/selectors';
import type { State as DashboardState } from '../redux/reducers';

const mapStateToProps = (state: {
  location: LocationState;
  dashboard: DashboardState;
  portfolios: PortfoliosState;
}): DashboardProps => {
  const { dashboard } = state;

  return {
    myMarketKeys: getMyMarketKeysSelector(state),
    myIndustryKeys: getMyIndustryKeysSelector(state),
    myMarketAndIndustryEntities: getMyMarketAndIndustryEntitiesSelector(state),
    myMarketsAndIndustriesLastUpdated:
      dashboard.myMarketsAndIndustriesLastUpdated,
    subRoute: state.location.payload.subRoute,
  };
};

export default connect(mapStateToProps)(Dashboard);
